import type { FormErrors } from 'react-typed-form/src/types';

import baseValidate from 'validate.js';

import { BUSY } from '../pods/client-tickets';

/**
 * Equivalent of built in validator: `presence: { allowEmpty: false }` because
 * that's nearly always what this app wants.
 */
baseValidate.validators.strictPresence = function (
  value: unknown,
  options: unknown,
  ...rest: unknown[]
) {
  return baseValidate.validators.presence(
    value,
    // options might be `true`
    { allowEmpty: false, ...(typeof options === 'object' ? options : {}) },
    ...rest
  );
};

/**
 * Allow undefined, i.e. when performing a PATCH of existing entity
 */
baseValidate.validators.optionalPresence = function (value: unknown) {
  if (
    value === null ||
    (value && typeof value === 'string' && value.trim() === '')
  ) {
    return "can't be blank";
  }
};

baseValidate.validators.passwordFormat = function (value: unknown) {
  return baseValidate.validators.format(value, {
    pattern: /(.*([A-Z].*[0-9]|[0-9].*[A-Z]).*)/,
    message:
      '^Password must contain at least one number and one capital letter',
  });
};

/**
 * Don't allow in progress uploads to be submitted.
 */
baseValidate.validators.upload = function (value: unknown) {
  if (value === BUSY) {
    return '^File is still uploading';
  }
};

export default function createFormValidator<T extends Record<string, unknown>>(
  constraints: Record<string, unknown>
): (values: T) => FormErrors<T> {
  return (values: T) => baseValidate(values, constraints) || {};
}
